import React from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

/**
 * Per-page browser tab <title> (WCAG 2.4.2 Page Titled). Each page declares its
 * own <PageTitle label="..." />; the tenant name is read from the portal
 * styling response (GET /portal/style/{customer}) so it stays interpolated in
 * one place rather than being repeated in every page.
 */
const PageTitle = ({ label }) => {
  const tenant =
    useSelector(
      (state) => state?.profileState?.profileDriverSetStyling?.pageTitle
    ) || "Driver Portal";

  return (
    <Helmet>
      <title>{label ? `${label} — ${tenant}` : tenant}</title>
    </Helmet>
  );
};

export default PageTitle;
